import React from 'react'
import styles from "./SearchField.module.scss"

const SearchField = (props) => {
    return (
        <div>
            {/* <input
                className={props?.modal ? styles.abs_search : styles.search}
                // className={styles.abs_search}
                {...props}
                onChange={props?.onChange}
                onClick={props?.onClick}
            /> */}
            <input
                className={styles.abs_search}
                // className={styles.abs_search}
                {...props}
                onChange={props?.onChange}
                onClick={props?.onClick}
            />
        </div>
    )
}

export default SearchField